import {
  faAngleDown,
  faAngleUp,
  faSortDown,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import forIn from 'lodash/forIn';
// import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import { toast } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import RadioCheckButton from './RadioCheckNew';
import {
  changeCategory,
  changeColor,
  changeCreatorName,
  changeExcludeCategory,
  changeExcludeCreatorName,
  changeExcludeKeyword,
  changeImageId,
  changeImageTitle,
  changeImageType,
  changeLicense,
  changeModelAge,
  changeModelCount,
  changeModelRelease,
  changeOpenAge,
  changeOpenCategory,
  changeOpenColor,
  changeOpenCreator,
  changeOpenImageTitle,
  changeOpenImageType,
  changeOpenKeywords,
  changeOpenLicense,
  changeOpenModelRelease,
  changeOpenNumberOfPeople,
  changeOpenOrderBy,
  changeOpenOrientation,
  changeOpenReleases,
  changeOrderBy,
  changeOrientation,
  changeShape,
  changeToggleFilterSearch,
  clearSearch,
} from '../actions';
import ColorPicker from '../ColorPicker';
import { selectSearch } from '../selectors';
import I18nRouter from '~/components/I18nRouter';
import IconX from '~/components/svg/icon-x.svg';
import Config from '~/config';
import {
  makeSelectCurrentLang,
  makeSelectIsLocaleInPath,
} from '~/containers/MetadataProvider/selectors';
import { searchPhoto } from '~/containers/SearchResultPage/actions';
import LocalStorage from '~/services/LocalStorage';
import themeVariables from '~/shared/themeVariables';
import { SEARCH_RESULT_ORDER } from '~/utils/constants';

const RefineSearch = ({
  searchState,
  onChangeImageTitle,
  onChangeImageId,
  onChangeOrderBy,
  t,
  onChangeExcludeKeyword,
  categories,
  onChangeCategory,
  onChangeExcludeCategory,
  onChangeCreatorName,
  // onChangeExcludeCreatorName,
  onChangeShape,
  onChangeColor,
  onChangeModelCount,
  onChangeModelAge,
  onChangeImageType,
  // onChangeOrientation,
  onChangeModelRelease,
  onClearSearch,
  // onSubmit,
  // onCloseRefineSearch,
  toggle,
  onChangeOpenOrderBy,
  onChangeOpenImageType,
  onChangeOpenOrientation,
  onChangeOpenKeywords,
  onChangeOpenCategory,
  onChangeOpenColor,
  onChangeOpenNumberOfPeople,
  onChangeOpenAge,
  // onChangeOpenModelRelease,
  onChangeOpenCreator,
  onChangeOpenImageTitle,
  onChangeOpenReleases,
  onChangeOpenLicense,
  onChangeLicense,
  onToggleFilterSearch,

  currentLang,
  query,
  isLocaleInPath,
  searchPhoto,
}) => {
  const {
    imageTitle,
    imageId,
    orderBy,
    color,
    excludeKeyword,
    category,
    excludeCategory,
    creatorName,
    // excludeCreatorName,
    shape,
    modelCount,
    license,
    modelAge,
    imageType,
    // orientation,
    modelRelease,
    openOrderBy,
    openImageType,
    openOrientation,
    openKeywords,
    openCategory,
    openColor,
    openNumberOfPeople,
    openAge,
    // openModelRelease,
    openCreator,
    openImageTitle,
    openReleases,
    openLicense,
  } = searchState;
  const [imageIdTmp, setImageIdTmp] = useState('');

  const [modelAgeOptions, _] = useState([
    // {
    //   label: t('all'),
    //   value: 'all',
    // },
    {
      label: t('baby'),
      value: 'A',
    },
    {
      label: t('children'),
      value: 'K',
    },
    {
      label: t('youth'),
      value: 'W',
    },
    {
      label: t('grown_up'),
      value: 'O',
    },
    {
      label: t('middle_aged'),
      value: 'C',
    },
    {
      label: t('senior_citizens'),
      value: 'S',
    },
  ]);

  const handleChangeImageTitle = (event) => {
    onChangeImageTitle({
      value: event.target.value,
      key: t('title'),
    });
  };

  const handleChangeImageId = (e) => {
    onChangeImageId({
      value: e,
      key: 'ID',
    });
  };

  const handleChangeOrder = (e) => {
    const dataTmp = {
      value: e,
      label:
        e === SEARCH_RESULT_ORDER.POPULAR
          ? t('popular')
          : e === SEARCH_RESULT_ORDER.NEWEST
          ? t('recent')
          : '',
    };
    onChangeOrderBy(dataTmp);
  };

  const handleChangeExcludeKeyword = (e) => {
    onChangeExcludeKeyword({
      value: e.target.value,
      key: t('Excuse keyword'),
    });
  };

  const handleChangeCategory = (selectedOption) => {
    const select = selectedOption.map((ele) => {
      return {
        ...ele,
        type: 'category',
        key: t('include_keyword'),
      };
    });
    onChangeCategory(select);
    // onSubmitMobile();
    // handleSubmitDesktop();
  };

  const handleChangeExcludeCategory = (selectedOption) => {
    const select = selectedOption.map((ele) => {
      return { ...ele, type: 'excludeCategory', key: t('exclude_keyword') };
    });
    onChangeExcludeCategory(select);
    // onSubmitMobile();
    // handleSubmitDesktop();
  };

  const handleChangeCreatorName = (e) => {
    onChangeCreatorName({
      value: e.target.value,
      key: t('creator_name'),
    });
  };

  // const handleChangeExcludeCreatorName = (e) => {
  //   onChangeExcludeCreatorName(e.target.value);
  // };

  const handleChangeShape = (e) => {
    const dataTmp = {
      value: e,
      label:
        e === 'vertical'
          ? t('Vertical')
          : e === 'horizontal'
          ? t('Horizontal')
          : t('all'),
      key: t('shape'),
    };
    onChangeShape(dataTmp);
  };

  const handleChangeColor = (value) => {
    onChangeColor(value);
    // onSubmitMobile();
    // handleSubmitDesktop();
  };

  const handleChangeModelCount = (e) => {
    const dataTmp = {
      value: e,
      // label: e === '-2' ? t('all') : e,
      label:
        e === '-2'
          ? t('all')
          : e === '0'
          ? t('count_people_0')
          : e === '1'
          ? t('count_people_1')
          : e === '2'
          ? t('count_people_2')
          : t('count_people_3'),
    };
    onChangeModelCount(dataTmp);
    // onSubmitMobile();
    // handleSubmitDesktop();
  };

  const handleChangeModelAge = (selectedOption) => {
    const select = selectedOption.map((ele) => {
      return { ...ele, type: 'modelAge' };
    });
    onChangeModelAge(select);
    // onSubmitMobile();
    // handleSubmitDesktop();
  };
  const hanleChangeImageType = (e) => {
    let dataTmp = {};
    if (Config.isIllustAC()) {
      dataTmp = {
        value: e,
        label: e === 'vector' ? 'EPS・AI' : 'PNG',
        key: 'Image Type',
      };
    }
    if (Config.isPhotoAC()) {
      dataTmp = {
        value: e,
        label: e === 'psd' ? 'PSD' : e === 'medium' ? 'M' : 'L',
        key: 'Image Type',
      };
    }
    onChangeImageType(dataTmp);
  };
  const hanleChangeLicense = (value) => {
    const dataTmp = {
      value,
      label: value === '0' ? t('without_extra_licenses') : t('extra_licenses'),
    };
    onChangeLicense(dataTmp);
  };
  // const handleChangeOrientation = (value) => {
  //   onChangeOrientation(value);
  // };
  const handleChangeModelRelease = (value) => {
    const dataTmp = {
      value,
      label:
        value === '0'
          ? t('model_releases_only')
          : value === '1'
          ? t('property_releases_only')
          : value === '2'
          ? t('without_releases')
          : '',
      key: 'Model Releases',
    };
    onChangeModelRelease(dataTmp);
  };
  // const handleClearSearch = () => {
  //   onClearSearch();
  // };
  const setOpenOrderBy = (value) => {
    onChangeOpenOrderBy(value);
  };
  const setOpenImageType = (value) => {
    onChangeOpenImageType(value);
  };
  const setOpenOrientation = (value) => {
    onChangeOpenOrientation(value);
  };
  const setOpenKeywords = (value) => {
    onChangeOpenKeywords(value);
  };
  const setOpenCategory = (value) => {
    onChangeOpenCategory(value);
  };
  const setOpenColor = (value) => {
    onChangeOpenColor(value);
  };
  const setOpenNumberOfPeople = (value) => {
    onChangeOpenNumberOfPeople(value);
  };
  const setOpenAge = (value) => {
    onChangeOpenAge(value);
  };
  const setOpenReleases = (value) => {
    onChangeOpenReleases(value);
  };
  const setOpenLicense = (value) => {
    onChangeOpenLicense(value);
  };
  const setOpenCreator = (value) => {
    onChangeOpenCreator(value);
  };
  const setOpenImageTitle = (value) => {
    onChangeOpenImageTitle(value);
  };
  // const [openOrderBy, setOpenOrderBy] = useState(false);
  // const [openImageType, setOpenImageType] = useState(false);
  // const [openOrientation, setOpenOrientation] = useState(false);
  // const [openKeywords, setOpenKeywords] = useState(false);
  // const [openCategory, setOpenCategory] = useState(false);
  // const [openColor, setOpenColor] = useState(false);
  // const [openNumberOfPeople, setOpenNumberOfPeople] = useState(false);
  // const [openAge, setOpenAge] = useState(false);
  // const [openModelRelease, setOpenModelRelease] = useState(false);
  // const [openCreator, setOpenCreator] = useState(false);
  // const [openImageTitle, setOpenImageTitle] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const onHandleSubmit = (values) => {
    if (
      !values.keyword &&
      !values.category &&
      !values.imageTitle &&
      !values.imageId &&
      // values.color === 'all' &&
      !values.creatorName
    ) {
      return toast.warn(t('search_message_not_input'), {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }

    values = { ...query, ...values };

    let asPath = '';
    forIn(values, (value, key) => {
      if (
        value &&
        key !== 'is_tag' &&
        key !== 'clientIp' &&
        key !== 'token' &&
        key !== 'keyword'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    LocalStorage.otherServices = null;

    let pageURL = `/search/${values.keyword}?${asPath}`;
    if (currentLang !== 'en' || isLocaleInPath) {
      pageURL = `/${currentLang}${pageURL}`;
    }

    if (imageId !== '') {
      searchPhoto({
        ...values,
        page: 1,
        keyword: '',
        excludeKeyword: values.excludeKeyword,
        category: values.category,
        excludeCategory: values.excludeCategory,
        creatorName: values.creatorName,
        excludeCreatorName: values.excludeCreatorName,
        color: values.color || 'all',
        modelCount: values.modelCount,
        modelAge: values.modelAge,
        isFromSearchHeader: true,
        // fileType: values.imageType,
        imageId: values.imageId,
        orderBy: values.orderBy,
        shape: values.shape,
        title: values.imageTitle,
        license: values.license,
        imageType: values.imageType,
        modelRelease: values.modelRelease,
      });
    } else {
      console.log('vo case k co id roi, ', values.imageId, values.keyword);
      searchPhoto({
        ...values,
        page: 1,
        keyword: values.keyword,
        excludeKeyword: values.excludeKeyword,
        category: values.category,
        excludeCategory: values.excludeCategory,
        creatorName: values.creatorName,
        excludeCreatorName: values.excludeCreatorName,
        color: values.color || 'all',
        modelCount: values.modelCount,
        modelAge: values.modelAge,
        isFromSearchHeader: true,
        // fileType: values.imageType,
        imageId: values.imageId,
        orderBy: values.orderBy,
        shape: values.shape,
        title: values.imageTitle,
        license: values.license,
        imageType: values.imageType,
        modelRelease: values.modelRelease,
      });
    }
    I18nRouter.push(
      {
        pathname: `/search/${values.keyword}`,
        query: {
          ...values,
          page: 1,
          keyword: values.keyword,
          excludeKeyword: values.excludeKeyword,
          category: values.category,
          excludeCategory: values.excludeCategory,
          creatorName: values.creatorName,
          excludeCreatorName: values.excludeCreatorName,
          color: values.color || 'all',
          modelCount: values.modelCount,
          modelAge: values.modelAge,
          isFromSearchHeader: true,
          // fileType: values.imageType,
          imageId: values.imageId,
          orderBy: values.orderBy,
          shape: values.shape,
          title: values.imageTitle,
          license: values.license,
          imageType: values.imageType,
          modelRelease: values.modelRelease,
        },
      },
      pageURL,
      { shallow: true },
    );
  };
  const onSubmitMobile = () => {
    let {
      keyword,
      excludeKeyword,
      category,
      excludeCategory,
      creatorName,
      excludeCreatorName,
      color,
      imageType,
      orderBy,
      shape,
      imageId,
      imageTitle,
      modelCount,
      modelAge,
      license,
      modelRelease,
    } = searchState;
    console.log('onSubmitMobileeeeeee', imageType, modelCount, modelRelease);

    category = category.map((item) => item.value).toString();
    excludeCategory = excludeCategory.map((item) => item.value).toString();
    modelAge = modelAge.map((item) => item.value).toString();
    // let ModelRelease = {};
    // if (modelRelease) {
    //   switch (modelRelease) {
    //     case '0':
    //       ModelRelease = { model: '2', property: '0' };
    //       break;
    //     case '1':
    //       ModelRelease = { model: '0', property: '2' };
    //       break;
    //     case '2':
    //       ModelRelease = { model: '0', property: '0' };
    //       break;
    //   }
    // }
    if (imageId) {
      onHandleSubmit({
        imageId,
      });
    } else {
      onHandleSubmit({
        keyword,
        excludeKeyword,
        category,
        excludeCategory,
        creatorName,
        excludeCreatorName,
        color: color || 'all',
        modelCount,
        modelAge,
        imageType,
        imageId,
        imageTitle,
        orderBy,
        shape,
        license,
        modelRelease,
        page: 1,
      });
    }
  };
  // const onToggleRefineSearchMobile = () => {
  //   // onCloseRefineSearch();
  // };
  const handleChangeToggleFilterSearch = (value) => {
    onToggleFilterSearch(value);
    LocalStorage.hideFilter = !value;
  };
  useEffect(() => {
    let { dataNow } = searchState;
    if (dataNow.length > 1) {
      setShowClear(true);
    } else {
      setShowClear(false);
    }
  }, [searchState]);

  useEffect(() => {
    // If search by photo, then don't submit
    if (query.image_token) return;
    if (!searchState.isLoaded) return;

    let isFilterChanged = false;
    const category = searchState.category.map((item) => item.value).join(',');
    const excludeCategory = searchState.excludeCategory
      .map((item) => item.value)
      .join(',');
    const modelAge = searchState.modelAge.map((item) => item.value).join(',');
    if (
      (query.color || searchState.color) &&
      query.color !== searchState.color
    ) {
      isFilterChanged = true;
      console.log('111111111111111', query.color, searchState.color);
    }
    if (
      (query.imageType || searchState.imageType) &&
      query.imageType !== searchState.imageType
    ) {
      isFilterChanged = true;
      console.log('22222222', query.imageType, searchState.imageType);
    }
    if (
      (query.orderBy || searchState.orderBy) &&
      query.orderBy !== searchState.orderBy
    ) {
      isFilterChanged = true;
      console.log('33333333', query.orderBy, searchState.orderBy);
    }
    if (query.shape && searchState.shape && query.shape !== searchState.shape) {
      isFilterChanged = true;
      console.log('4444444444', query.shape, searchState.shape);
    }
    if (
      (query.modelCount || searchState.modelCount) &&
      query.modelCount !== searchState.modelCount
    ) {
      isFilterChanged = true;
      console.log('555555555555', query.modelCount, searchState.modelCount);
    }
    if ((query.modelAge || modelAge) && query.modelAge !== modelAge) {
      isFilterChanged = true;
      console.log('6666666666', query.modelAge, modelAge);
    }
    if (
      (query.license || searchState.license) &&
      query.license !== searchState.license
    ) {
      isFilterChanged = true;
      console.log('777777777', query.license, searchState.license);
    }
    if (
      (query.modelRelease || searchState.modelRelease) &&
      query.modelRelease !== searchState.modelRelease
    ) {
      isFilterChanged = true;
      console.log('888888888888', query.modelRelease, searchState.modelRelease);
    }
    if ((query.category || category) && query.category !== category) {
      isFilterChanged = true;
      console.log('99999999999', query.category, category);
    }
    if (
      (query.excludeCategory || excludeCategory) &&
      query.excludeCategory !== excludeCategory
    ) {
      isFilterChanged = true;
      console.log('1010101010101111', query.excludeCategory, excludeCategory);
    }
    if (query.imageId !== imageId) {
      isFilterChanged = true;
    }
    // Only automatically submit search in tablet or desktop
    if (
      isFilterChanged &&
      window.innerWidth > themeVariables.breakpoints.mobile.maxWidth
    ) {
      onSubmitMobile();
    }
  }, [
    searchState.color,
    searchState.imageType,
    searchState.orderBy,
    searchState.shape,
    searchState.modelCount,
    searchState.modelAge,
    searchState.license,
    searchState.modelRelease,
    searchState.category,
    searchState.excludeCategory,
    searchState.imageId,
  ]);
  useEffect(() => {
    setImageIdTmp(searchState.imageId);
  }, [searchState.imageId]);
  const CustomSelect = ({ children, getValue, ...props }) => {
    const selectedValue = getValue();
    return (
      <components.ValueContainer {...props}>
        {selectedValue.length > 0 ? (
          <span className="category-count-chosen">{`${selectedValue.length} ${t(
            'chosen',
          )}`}</span>
        ) : (
          <span className="count-chosen-item">{t('select_category')}</span>
        )}
        <div className="children-select">{children}</div>
      </components.ValueContainer>
    );
  };

  return (
    <div
      className={toggle ? 'nav-submenu-wrapper toggle' : 'nav-submenu-wrapper'}
    >
      <div className="action-mobile">
        <div
          className="header-filter-responsive"
          // onClick={() => onToggleRefineSearchMobile()}
        >
          <div className="filter-action">
            <div
              onClick={() => {
                // onToggleRefineSearch();
                handleChangeToggleFilterSearch(false);
              }}
              className="refine-text"
            >
              <div className="filter-action">
                <div
                  // onClick={() => {
                  //   // onToggleRefineSearch();
                  //   handleChangeToggleFilterSearch(false);
                  // }}
                  className="refine-text"
                >
                  <div className="refine-text-container">
                    <img
                      src={`${Config.staticPrefix}/static/assets/svg/filter-search.svg`}
                      width={'24'}
                      height={'21'}
                      alt="icon filter search"
                    />
                    <span className="text-refine-search m-l-10">
                      {t('filter')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-item-action">
            <div
              className="icon-dropdown-hidden-filter-mobile"
              onClick={() => {
                handleChangeToggleFilterSearch(false);
              }}
            >
              <IconX />
              {/* <FontAwesomeIcon
                onClick={() => {
                  handleChangeToggleFilterSearch(false);
                }}
                fixedWidth
                icon={faChevronRight}
              ></FontAwesomeIcon> */}
            </div>
            {!showClear ? (
              <div className={'clear-container'}>
                <p className={'clear-text '}>{t('clear')}</p>
              </div>
            ) : (
              <div
                className={'clear-container'}
                onClick={() => {
                  onClearSearch();
                  // onSubmitMobile();
                }}
              >
                <p className={'clear-text active'}>{t('clear')}</p>
              </div>
            )}
            <div
              className="search-icon-container"
              onClick={() => {
                onSubmitMobile();
              }}
            >
              <img
                src={`${Config.staticPrefix}/static/assets/svg/icon-search.svg`}
                width={'24'}
                height={'21'}
                alt="icon filter search"
              />
            </div>
            <div
              className="icon-dropdown-hidden-filter"
              onClick={() => {
                handleChangeToggleFilterSearch(false);
              }}
            >
              <FontAwesomeIcon
                style={{ width: 16 }}
                icon={faChevronLeft}
              ></FontAwesomeIcon>
            </div>
          </div>
        </div>
        <div className="header-filter-action">
          <button
            className={`clear-filter apply ${Config.serviceType}`}
            type="button"
            onClick={() => {
              onSubmitMobile();
              handleChangeToggleFilterSearch(false);
            }}
          >
            {t('apply')}
          </button>
          <button
            className={`clear-filter clear ${Config.serviceType}`}
            type="button"
            onClick={() => {
              onClearSearch();
            }}
          >
            {t('clear')}
          </button>
        </div>
      </div>
      <div className="action-desktop">
        <div
          className="header-filter-responsive"
          // onClick={() => handleChangeToggleFilterSearch(false)}
        >
          <div
            className="icon-dropdown-hidden-filter"
            onClick={() => {
              handleChangeToggleFilterSearch(false);
            }}
          >
            <FontAwesomeIcon
              style={{ width: 16 }}
              icon={faChevronLeft}
            ></FontAwesomeIcon>
          </div>
          <div className="filter-action">
            <div
              // onClick={() => {
              //   // onToggleRefineSearch();
              //   handleChangeToggleFilterSearch(false);
              // }}
              className="refine-text"
            >
              <div className="refine-text-container">
                <img
                  src={`${Config.staticPrefix}/static/assets/svg/filter-search.svg`}
                  width={'24'}
                  height={'21'}
                  alt="icon filter search"
                />
                <span className="text-refine-search m-l-10">{t('filter')}</span>
              </div>
            </div>
          </div>

          <div className="container-item-action">
            {!showClear ? (
              <div className={'clear-container'}>
                <p className={'clear-text '}>{t('clear')}</p>
              </div>
            ) : (
              <div
                className={'clear-container'}
                onClick={() => {
                  onClearSearch();
                  // onSubmitMobile();
                  // handleSubmitDesktop();
                }}
              >
                <p className={'clear-text active'}>{t('clear')}</p>
              </div>
            )}
            <div
              className="search-icon-container"
              onClick={() => {
                onSubmitMobile();
              }}
            >
              <img
                src={`${Config.staticPrefix}/static/assets/svg/icon-search.svg`}
                width={'24'}
                height={'21'}
                alt="icon filter search"
              />
            </div>
          </div>
        </div>

        <div className="header-filter-action">
          <button
            className={`clear-filter apply ${Config.serviceType}`}
            type="button"
            onClick={() => {
              onSubmitMobile();
              // onToggleRefineSearchMobile();
            }}
          >
            {t('apply')}
          </button>
          <button
            className={`clear-filter clear ${Config.serviceType}`}
            type="button"
            onClick={() => {
              onClearSearch();
            }}
          >
            {t('clear')}
          </button>
        </div>
      </div>
      <div className="nav-submenu">
        <div className="submenu-list">
          <div className="submenu">
            <div className="submenu-item">
              <a
                onClick={() => setOpenOrderBy(!openOrderBy)}
                aria-controls="orderBy"
                aria-expanded={openOrderBy}
                className="submenu-item-title"
              >
                {t('sort_by')}
              </a>{' '}
              <i className="icon-dropdown">
                <FontAwesomeIcon
                  onClick={() => setOpenOrderBy(!openOrderBy)}
                  fixedWidth
                  icon={openOrderBy ? faAngleDown : faAngleUp}
                ></FontAwesomeIcon>
              </i>
            </div>
            <Collapse in={openOrderBy} className="submenu-item-collapse">
              <div id="orderBy">
                <div className="submenu-item-radio sort-by">
                  <div className="sub-radio-container">
                    <RadioCheckButton
                      // groupName="Orientation"
                      checked={orderBy === SEARCH_RESULT_ORDER.ALL_IMAGES}
                      label={t('all_images')}
                      onChange={() => {
                        handleChangeOrder(SEARCH_RESULT_ORDER.ALL_IMAGES);
                        // onSubmitMobile();
                      }}
                      width={'100%'}
                    />
                  </div>
                  <div className="sub-radio-container calc">
                    <RadioCheckButton
                      checked={orderBy === SEARCH_RESULT_ORDER.POPULAR}
                      label={t('popular')}
                      onChange={() => {
                        handleChangeOrder(SEARCH_RESULT_ORDER.POPULAR);
                        // onSubmitMobile();
                        // handleSubmitDesktop();
                      }}
                      width={'100%'}
                    />

                    <RadioCheckButton
                      checked={orderBy === SEARCH_RESULT_ORDER.NEWEST}
                      label={t('recent')}
                      onChange={() => {
                        handleChangeOrder(SEARCH_RESULT_ORDER.NEWEST);
                        // onSubmitMobile();
                        // handleSubmitDesktop();
                      }}
                      width={'100%'}
                    />
                  </div>
                  {/* <Radio
                    // groupName="orderBy"
                    onChange={() => handleChangeOrder('popular')}
                    checked={orderBy === 'popular'}
                    label={t('popular')}
                    // label="Most Relevant"
                  />
                  <Radio
                    // groupName="orderBy"
                    onChange={() => handleChangeOrder('newest')}
                    checked={orderBy === 'newest'}
                    label={t('recent')}
                  />
                  <Radio
                    // groupName="orderBy"
                    onChange={() => handleChangeOrder('random')}
                    checked={orderBy === 'random'}
                    label={t('random')}
                  /> */}
                </div>
              </div>
            </Collapse>
          </div>

          <div className="submenu">
            <div className="submenu-item">
              <a
                onClick={() => setOpenKeywords(!openKeywords)}
                aria-controls="ExcludeKeyword"
                aria-expanded={openKeywords}
                className="submenu-item-title"
              >
                {t('Excuse keyword')}
              </a>{' '}
              <i className="icon-dropdown">
                <FontAwesomeIcon
                  onClick={() => setOpenKeywords(!openKeywords)}
                  fixedWidth
                  icon={openKeywords ? faAngleDown : faAngleUp}
                ></FontAwesomeIcon>
              </i>
            </div>
            <Collapse in={openKeywords} className="submenu-item-collapse">
              <div id="ExcludeKeyword">
                <div className="submenu-item-radio excludekeyword">
                  <input
                    type="text"
                    onChange={handleChangeExcludeKeyword}
                    value={excludeKeyword}
                    className="form-control input-text-filter"
                    placeholder={t('enter_keyword_here')}
                    onKeyDown={(event) => {
                      if (event.keyCode === 13) {
                        onSubmitMobile();
                      }
                    }}
                  />
                  <small>{t('separate_word_with_comma')}</small>
                </div>
              </div>
            </Collapse>
          </div>

          {(Config.isIllustAC() || Config.isPhotoAC()) && (
            <div className="submenu">
              <div className="submenu-item">
                <a
                  onClick={() => setOpenImageType(!openImageType)}
                  aria-controls="ImageType"
                  aria-expanded={openImageType}
                  className="submenu-item-title"
                >
                  {t('images_type')}
                </a>{' '}
                <i className="icon-dropdown">
                  <FontAwesomeIcon
                    onClick={() => setOpenImageType(!openImageType)}
                    fixedWidth
                    icon={openImageType ? faAngleDown : faAngleUp}
                  ></FontAwesomeIcon>
                </i>
              </div>
              <Collapse in={openImageType} className="submenu-item-collapse">
                <div id="ImageType">
                  <div className="submenu-item-radio shape">
                    <div className="sub-radio-container">
                      <RadioCheckButton
                        // groupName="Orientation"
                        checked={imageType === ''}
                        label={t('all_images')}
                        onChange={() => {
                          hanleChangeImageType('');
                          // onSubmitMobile();
                          // handleSubmitDesktop();
                        }}
                        width={'100%'}
                      />
                    </div>
                    {Config.isPhotoAC() && (
                      <div className="sub-radio-container calc">
                        <RadioCheckButton
                          checked={imageType === 'psd'}
                          label={'PSD'}
                          onChange={() => {
                            hanleChangeImageType('psd');
                            // onSubmitMobile();
                          }}
                          width={'100%'}
                        />

                        <RadioCheckButton
                          checked={imageType === 'medium'}
                          label={'M'}
                          onChange={() => {
                            hanleChangeImageType('medium');
                            // onSubmitMobile();
                          }}
                          width={'100%'}
                        />
                        <RadioCheckButton
                          checked={imageType === 'large'}
                          label={'L'}
                          onChange={() => {
                            hanleChangeImageType('large');
                            // onSubmitMobile();
                          }}
                          width={'100%'}
                        />
                      </div>
                    )}
                    {Config.isIllustAC() && (
                      <div className="sub-radio-container calc">
                        <RadioCheckButton
                          checked={imageType === 'vector'}
                          label={'EPS・AI'}
                          onChange={() => {
                            hanleChangeImageType('vector');
                            // onSubmitMobile();
                            // handleSubmitDesktop();
                          }}
                          width={'100%'}
                        />

                        <RadioCheckButton
                          checked={imageType === 'png'}
                          label={'PNG'}
                          onChange={() => {
                            hanleChangeImageType('png');
                            // onSubmitMobile();
                            // handleSubmitDesktop();
                          }}
                          width={'100%'}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Collapse>
            </div>
          )}

          <div className="submenu">
            <div className="submenu-item">
              <a
                onClick={() => setOpenOrientation(!openOrientation)}
                aria-controls="Orientation"
                aria-expanded={openOrientation}
                className="submenu-item-title"
              >
                {t('shape')}
              </a>{' '}
              <i className="icon-dropdown">
                <FontAwesomeIcon
                  onClick={() => setOpenOrientation(!openOrientation)}
                  fixedWidth
                  icon={openOrientation ? faAngleDown : faAngleUp}
                ></FontAwesomeIcon>
              </i>
            </div>
            <Collapse in={openOrientation} className="submenu-item-collapse">
              <div id="Orientation">
                <div className="submenu-item-radio shape">
                  <div className="sub-radio-container">
                    <RadioCheckButton
                      // groupName="Orientation"
                      checked={shape === 'all'}
                      label={t('all_images')}
                      onChange={() => {
                        handleChangeShape('all');
                        // onSubmitMobile();
                        // handleSubmitDesktop();
                      }}
                      width={'100%'}
                    />
                  </div>
                  <div className="sub-radio-container calc">
                    <RadioCheckButton
                      checked={shape === 'vertical'}
                      label={t('Vertical')}
                      onChange={() => {
                        handleChangeShape('vertical');
                        // onSubmitMobile();
                        // handleSubmitDesktop();
                      }}
                      width={'100%'}
                    />

                    <RadioCheckButton
                      checked={shape === 'horizontal'}
                      label={t('Horizontal')}
                      onChange={() => {
                        handleChangeShape('horizontal');
                        // onSubmitMobile();
                        // handleSubmitDesktop();
                      }}
                      width={'100%'}
                    />
                  </div>
                  {/* <Radio
                    // groupName="Orientation"
                    checked={shape === 'Vertical'}
                    label={t('Vertical')}
                    onChange={() => handleChangeShape('Vertical')}
                  />
                  <Radio
                    // groupName="Orientation"
                    checked={shape === 'Horizontal'}
                    label={t('Horizontal')}
                    onChange={() => handleChangeShape('Horizontal')}
                  />
                  <Radio
                    // groupName="Orientation"
                    checked={shape === 'all'}
                    label={t('all')}
                    onChange={() => handleChangeShape('all')}
                  /> */}
                </div>
              </div>
            </Collapse>
          </div>

          <div className="submenu submenu-category">
            <div className="submenu-item">
              <a
                onClick={() => setOpenCategory(!openCategory)}
                aria-controls="Category"
                aria-expanded={openCategory}
                className="submenu-item-title"
              >
                {t('category')}
              </a>{' '}
              <i className="icon-dropdown">
                <FontAwesomeIcon
                  onClick={() => setOpenCategory(!openCategory)}
                  fixedWidth
                  icon={openCategory ? faAngleDown : faAngleUp}
                ></FontAwesomeIcon>
              </i>
            </div>
            <Collapse in={openCategory} className="submenu-item-collapse">
              <div id="Category">
                <div className="submenu-item-radio category">
                  <span style={{ flex: 1 }}>{t('include')}</span>
                  <span
                    className="select-category"
                    style={{ marginLeft: 10, flex: 3, marginRight: 8 }}
                  >
                    <Select
                      // placeholder={t('select_category')}
                      style={{ borderRadius: 10, fontSize: 14 }}
                      instanceId={1}
                      className="submenu-item-dropdown"
                      classNamePrefix="search-dropdown-select"
                      value={category}
                      hideSelectedOptions={false}
                      isMulti
                      placeholder=""
                      onChange={handleChangeCategory}
                      onKeyDown={(event) => {
                        if (event.keyCode === 13) {
                          onSubmitMobile();
                        }
                      }}
                      options={categories.filter(
                        (v) => !excludeCategory.includes(v),
                      )}
                      components={{ ValueContainer: CustomSelect }}
                    />
                  </span>
                </div>
                {/* {
                        DropdownIndicator() {
                          return (
                            <FontAwesomeIcon
                              icon={faSortDown}
                              style={{
                                position: 'absolute',
                                right: 4,
                                top: 8,
                                width: 8,
                              }}
                            />
                          );
                        },
                        IndicatorSeparator: () => null,
                      } */}
                <div
                  className="submenu-item-radio category"
                  style={{ marginTop: 5 }}
                >
                  <span style={{ flex: 1 }}>{t('exclude')}</span>
                  <span
                    className="select-category"
                    style={{ marginLeft: 10, flex: 3, marginRight: 8 }}
                  >
                    <Select
                      style={{ borderRadius: 10, fontSize: 14 }}
                      instanceId={2}
                      className="submenu-item-dropdown"
                      classNamePrefix="search-dropdown-select"
                      isMulti
                      placeholder=""
                      hideSelectedOptions={false}
                      value={excludeCategory}
                      onChange={handleChangeExcludeCategory}
                      onKeyDown={(event) => {
                        if (event.keyCode === 13) {
                          onSubmitMobile();
                        }
                      }}
                      options={categories.filter((v) => !category.includes(v))}
                      components={{
                        ValueContainer: CustomSelect,
                      }}
                    />
                  </span>
                </div>
              </div>
            </Collapse>
          </div>

          {(Config.isPhotoAC() || Config.isIllustAC()) && (
            <div className="submenu">
              <div className="submenu-item">
                <a
                  onClick={() => setOpenColor(!openColor)}
                  aria-controls="Color"
                  aria-expanded={openColor}
                  className="submenu-item-title"
                >
                  {t('color')}
                </a>{' '}
                <i className="icon-dropdown">
                  <FontAwesomeIcon
                    onClick={() => setOpenColor(!openColor)}
                    fixedWidth
                    icon={openColor ? faAngleDown : faAngleUp}
                  ></FontAwesomeIcon>
                </i>
              </div>
              <Collapse in={openColor}>
                <div id="Color">
                  <div className="submenu-item-radio color">
                    <div className="sub-radio-container">
                      <RadioCheckButton
                        // groupName="Orientation"
                        checked={color === 'all'}
                        label={t('all_images')}
                        onChange={() => {
                          handleChangeColor('all');
                        }}
                        width={'100%'}
                      />
                    </div>
                    <span className="select-color">
                      {/* <Radio
                        onChange={() => handleChangeColor('all')}
                        checked={color === 'all'}
                        label={t('all')}
                        style={{ marginRight: 16 }}
                      /> */}

                      <ColorPicker
                        value={color}
                        t={t}
                        onChange={handleChangeColor}
                      />
                    </span>
                  </div>
                </div>
              </Collapse>
            </div>
          )}

          {Config.isPhotoAC() && (
            <div className="submenu">
              <div className="submenu-item">
                <a
                  onClick={() => setOpenNumberOfPeople(!openNumberOfPeople)}
                  aria-controls="NumberPeople"
                  aria-expanded={openNumberOfPeople}
                  className="submenu-item-title"
                >
                  {t('number_models')}
                </a>{' '}
                <i className="icon-dropdown">
                  <FontAwesomeIcon
                    onClick={() => setOpenNumberOfPeople(!openNumberOfPeople)}
                    fixedWidth
                    icon={openNumberOfPeople ? faAngleDown : faAngleUp}
                  ></FontAwesomeIcon>
                </i>
              </div>
              <Collapse
                in={openNumberOfPeople}
                className="submenu-item-collapse"
              >
                <div id="NumberPeople">
                  <div className="submenu-item-radio number-people">
                    <div className="sub-radio-container">
                      <RadioCheckButton
                        // groupName="Orientation"
                        checked={modelCount === '-2'}
                        label={t('all_images')}
                        onChange={() => {
                          handleChangeModelCount('-2');
                          // onSubmitMobile();
                        }}
                        width={'100%'}
                      />
                    </div>
                    <div className="sub-radio-container number-people">
                      <RadioCheckButton
                        onChange={() => {
                          handleChangeModelCount('0');
                          // onSubmitMobile();
                        }}
                        checked={modelCount === '0'}
                        label={'0'}
                        width={'100%'}
                      />
                      <RadioCheckButton
                        onChange={() => {
                          handleChangeModelCount('1');
                          // onSubmitMobile();
                        }}
                        checked={modelCount === '1'}
                        label={'1'}
                        width={'100%'}
                      />
                      <RadioCheckButton
                        onChange={() => {
                          handleChangeModelCount('2');
                          // onSubmitMobile();
                        }}
                        checked={modelCount === '2'}
                        label={'2'}
                        width={'100%'}
                      />
                      <RadioCheckButton
                        onChange={() => {
                          handleChangeModelCount('3');
                          // onSubmitMobile();
                        }}
                        checked={modelCount === '3'}
                        label={'3+'}
                        width={'100%'}
                      />
                    </div>

                    {/* <Radio
                      // groupName="modelCount"
                      onChange={() => handleChangeModelCount('0')}
                      checked={modelCount === '0'}
                      label={t('count_people_0')}
                    />
                    <Radio
                      // groupName="modelCount"
                      onChange={() => handleChangeModelCount('1')}
                      checked={modelCount === '1'}
                      label={t('count_people_1')}
                    />
                    <Radio
                      // groupName="modelCount"
                      onChange={() => handleChangeModelCount('2')}
                      checked={modelCount === '2'}
                      label={t('count_people_2')}
                    />
                    <Radio
                      // groupName="modelCount"
                      onChange={() => handleChangeModelCount('3')}
                      checked={modelCount === '3'}
                      label={t('count_people_3')}
                    />
                    <Radio
                      // groupName="modelCount"
                      onChange={() => handleChangeModelCount('-2')}
                      checked={modelCount === '-2'}
                      label={t('all')}
                    /> */}
                  </div>
                </div>
              </Collapse>
            </div>
          )}

          {Config.isPhotoAC() && (
            <>
              <div className="submenu">
                <div className="submenu-item">
                  <a
                    onClick={() => setOpenAge(!openAge)}
                    aria-controls="Age"
                    aria-expanded={openAge}
                    className="submenu-item-title"
                  >
                    {t('model_age')}
                  </a>
                  <i className="icon-dropdown">
                    <FontAwesomeIcon
                      onClick={() => setOpenAge(!openAge)}
                      fixedWidth
                      icon={openAge ? faAngleDown : faAngleUp}
                    ></FontAwesomeIcon>
                  </i>
                </div>
                <Collapse in={openAge} className="submenu-item-collapse">
                  <div id="Age">
                    <div className="submenu-item-radio age">
                      <span className="selectAge">
                        <Select
                          placeholder="All ages"
                          instanceId={2}
                          className="submenu-item-dropdown"
                          classNamePrefix={`search-dropdown-${Config.serviceType}`}
                          value={modelAge}
                          isMulti
                          onChange={handleChangeModelAge}
                          options={modelAgeOptions}
                          components={{
                            DropdownIndicator() {
                              return (
                                <FontAwesomeIcon
                                  icon={faSortDown}
                                  style={{
                                    position: 'absolute',
                                    right: 4,
                                    top: 8,
                                    width: 8,
                                  }}
                                />
                              );
                            },
                            IndicatorSeparator: () => null,
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </Collapse>
              </div>

              <div className="submenu">
                <div className="submenu-item">
                  <a
                    onClick={() => setOpenReleases(!openReleases)}
                    aria-controls="Age"
                    aria-expanded={openReleases}
                    className="submenu-item-title"
                  >
                    {t('releases')}
                  </a>
                  <i className="icon-dropdown">
                    <FontAwesomeIcon
                      onClick={() => setOpenReleases(!openReleases)}
                      fixedWidth
                      icon={openReleases ? faAngleDown : faAngleUp}
                    ></FontAwesomeIcon>
                  </i>
                </div>
                <Collapse in={openReleases} className="submenu-item-collapse">
                  <div id="Age">
                    <div className="submenu-item-radio release">
                      <div className="sub-item-container">
                        <RadioCheckButton
                          label={t('all_images')}
                          checked={modelRelease === ''}
                          width={'100%'}
                          position={'left'}
                          style={{ paddingLeft: 16 }}
                          onChange={() => {
                            handleChangeModelRelease('');
                            // onSubmitMobile();
                          }}
                        />
                      </div>
                      <div className="sub-item-container">
                        <RadioCheckButton
                          label={t('model_releases_only')}
                          checked={modelRelease === '0'}
                          width={'100%'}
                          position={'left'}
                          style={{ paddingLeft: 16 }}
                          onChange={() => {
                            handleChangeModelRelease('0');
                            // onSubmitMobile();
                          }}
                        />
                      </div>
                      <div className="sub-item-container">
                        <RadioCheckButton
                          label={t('property_releases_only')}
                          checked={modelRelease === '1'}
                          width={'100%'}
                          position={'left'}
                          style={{ paddingLeft: 16 }}
                          onChange={() => {
                            handleChangeModelRelease('1');
                            // onSubmitMobile();
                          }}
                        />
                      </div>
                      <div className="sub-item-container">
                        <RadioCheckButton
                          label={t('without_releases')}
                          checked={modelRelease === '2'}
                          width={'100%'}
                          position={'left'}
                          style={{ paddingLeft: 16 }}
                          onChange={() => {
                            handleChangeModelRelease('2');
                            // onSubmitMobile();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </>
          )}

          {!Config.isDesignAC() && !Config.isSilhouetteAC() && (
            <div className="submenu">
              <div className="submenu-item">
                <a
                  onClick={() => setOpenLicense(!openLicense)}
                  aria-controls="License"
                  aria-expanded={openLicense}
                  className="submenu-item-title"
                >
                  {t('license')}
                </a>
                <i className="icon-dropdown">
                  <FontAwesomeIcon
                    onClick={() => setOpenLicense(!openLicense)}
                    fixedWidth
                    icon={openLicense ? faAngleDown : faAngleUp}
                  ></FontAwesomeIcon>
                </i>
              </div>
              <Collapse in={openLicense} className="submenu-item-collapse">
                <div id="License">
                  <div className="submenu-item-radio license">
                    <div className="sub-item-container">
                      <RadioCheckButton
                        label={t('all_images')}
                        width={'100%'}
                        position={'left'}
                        style={{ paddingLeft: 16 }}
                        checked={license === ''}
                        onChange={() => {
                          hanleChangeLicense('');
                          // onSubmitMobile();
                          // handleSubmitDesktop();
                        }}
                      />
                    </div>
                    <div className="sub-item-container">
                      <RadioCheckButton
                        label={t('extra_licenses')}
                        width={'100%'}
                        position={'left'}
                        style={{ paddingLeft: 16 }}
                        checked={license === '1'}
                        onChange={() => {
                          hanleChangeLicense('1');
                          // onSubmitMobile();
                          // handleSubmitDesktop();
                        }}
                      />
                    </div>
                    <div className="sub-item-container">
                      <RadioCheckButton
                        label={t('without_extra_licenses')}
                        width={'100%'}
                        position={'left'}
                        style={{ paddingLeft: 16 }}
                        checked={license === '0'}
                        onChange={() => {
                          hanleChangeLicense('0');
                          // onSubmitMobile();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          )}
          {!Config.isSilhouetteAC() && (
            <div className="submenu">
              <div className="submenu-item">
                <a
                  onClick={() => setOpenCreator(!openCreator)}
                  aria-controls="Creator"
                  aria-expanded={openCreator}
                  className="submenu-item-title"
                >
                  {t('creator_name')}
                </a>{' '}
                <i className="icon-dropdown">
                  <FontAwesomeIcon
                    onClick={() => setOpenCreator(!openCreator)}
                    fixedWidth
                    icon={openCreator ? faAngleDown : faAngleUp}
                  ></FontAwesomeIcon>
                </i>
              </div>
              <Collapse in={openCreator} className="submenu-item-collapse">
                <div id="Creator">
                  <div className="submenu-item-radio creator">
                    <input
                      placeholder={t('enter_creator_name')}
                      type="text"
                      onChange={handleChangeCreatorName}
                      value={creatorName}
                      className="form-control input-text-filter"
                      onKeyDown={(event) => {
                        if (event.keyCode === 13) {
                          onSubmitMobile();
                        }
                      }}
                    />
                  </div>
                </div>
              </Collapse>
            </div>
          )}
          <div className="submenu">
            <div className="submenu-item">
              <a
                onClick={() => setOpenImageTitle(!openImageTitle)}
                aria-controls="ImageTitle"
                aria-expanded={openImageTitle}
                className="submenu-item-title"
              >
                {t('image_title_id')}
              </a>{' '}
              <i className="icon-dropdown">
                <FontAwesomeIcon
                  onClick={() => setOpenImageTitle(!openImageTitle)}
                  fixedWidth
                  icon={openImageTitle ? faAngleDown : faAngleUp}
                ></FontAwesomeIcon>
              </i>
            </div>
            <Collapse in={openImageTitle} className="submenu-item-collapse">
              <div id="ImageTitle">
                <div className="submenu-item-radio imagetitle">
                  <div className="imageTitle">
                    <span style={{ width: '15%' }}>{t('title')}</span>
                    <span
                      className="selectImageTitle"
                      style={{ marginLeft: 10, flexGrow: 1 }}
                    >
                      <input
                        placeholder={t('enter_title')}
                        type="text"
                        onChange={handleChangeImageTitle}
                        value={imageTitle}
                        className="form-control input-text-filter"
                        onKeyDown={(event) => {
                          if (event.keyCode === 13) {
                            onSubmitMobile();
                          }
                        }}
                      />
                    </span>
                  </div>
                  <div className="imageTitle">
                    <span style={{ width: '15%' }}>ID</span>
                    <span
                      className="selectImageTitle"
                      style={{ marginLeft: 10, flexGrow: 1 }}
                    >
                      <input
                        placeholder={t('enter_image_id')}
                        type="text"
                        onChange={(e) => {
                          if (event.keyCode !== 13) {
                            setImageIdTmp(e.target.value);
                          }
                        }}
                        value={imageIdTmp}
                        className="form-control input-text-filter"
                        onKeyDown={(event) => {
                          if (event.keyCode === 13) {
                            handleChangeImageId(imageIdTmp);
                            // onSubmitMobile();
                          }
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
      <div className="header-filter-action-bottom">
        <button
          className={`clear-filter clear ${Config.serviceType}`}
          type="button"
          onClick={() => {
            onClearSearch();
          }}
        >
          {t('clear')}
        </button>
        <button
          className={`clear-filter apply ${Config.serviceType}`}
          type="button"
          onClick={() => {
            onSubmitMobile();
            // onToggleRefineSearchMobile();
            handleChangeToggleFilterSearch(false);
          }}
        >
          {t('filter')}
        </button>
      </div>
      <style jsx global>
        {`
          .nav-submenu .submenu-item-radio .ac-radio label {
            font-size: 14px;
            line-height: 21px;
            color: #000000;
            font-family: Work Sans;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 18px;
            color: #000000;
          }
          .search-result-page
            .container-service
            .nav-submenu
            .submenu-item-radio
            .ac-radio
            label {
            font-size: 14px;
            line-height: 21px;
            color: #000000;
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 18px;
            color: #000000;
          }
          .children-select {
            z-index: -1;
          }
          .search-dropdown-select__control {
            height: 40px !important;
            border-color: hsl(0, 0%, 80%) !important;
            box-shadow: none !important;
          }
          .search-dropdown-select__indicators {
            height: 40px !important;
          }
          .category-count-chosen {
            margin-top: 6px;
          }
          .search-dropdown-select__control--is-focused {
            color: none;
            border-color: none;
          }
          .submenu-category {
            background: #fff;
          }
          .count-chosen-item {
            color: #c4c4c4;
          }
          .input-text-filter {
            border: 1px solid #b8b8b8;
            box-shadow: none;
            height: 40px;
            ${Config.isIllustAC()
              ? 'border-radius: 40px; '
              : 'border-radius: 4px; background: #f2f3f4;'}
          }
          .search-dropdown-design_ac__multi-value {
            background: #ffa823;
          }
          ${Config.isIllustAC() &&
          `.search-dropdown-illust_ac__control{
              border-radius: 40px;
              cursor: pointer;
            }
            `}
          .search-dropdown-design_ac__multi-value
            .search-dropdown-design_ac__multi-value__label {
            color: #fff;
          }

          .search-dropdown-design_ac__multi-value
            .search-dropdown-design_ac__multi-value__remove {
            color: #fff;
          }
          .search-dropdown-illust_ac__multi-value {
            background: #d73a4e;
          }

          .search-dropdown-illust_ac__multi-value
            .search-dropdown-illust_ac__multi-value__label {
            color: #fff;
          }

          .search-dropdown-illust_ac__multi-value
            .search-dropdown-illust_ac__multi-value__remove {
            color: #fff;
          }
          .search-dropdown-silhouette_ac__multi-value {
            background: #41b9b8;
          }

          .search-dropdown-silhouette_ac__multi-value
            .search-dropdown-silhouette_ac__multi-value__label {
            color: #fff;
          }

          .search-dropdown-silhouette_ac__multi-value
            .search-dropdown-silhouette_ac__multi-value__remove {
            color: #fff;
          }
          .search-dropdown-photo_ac__multi-value {
            background: #509bdc;
          }

          .search-dropdown-photo_ac__multi-value
            .search-dropdown-photo_ac__multi-value__label {
            color: #fff;
          }

          .search-dropdown-photo_ac__multi-value
            .search-dropdown-photo_ac__multi-value__remove {
            color: #fff;
          }
        `}
      </style>
      <style jsx>
        {`
          .refine-text-container {
            display: flex;
            gap: 12px;
          }
          .header-filter-action-bottom {
            display: none;
            flex-direction: row;
            justify-content: space-between;
            position: fixed;
            bottom: 0;
            background: #fff;
            width: calc(100%);
            padding: 8px 0;
            border-top: 1px solid #c4c4c4;
            z-index: 999;
            padding: 16px;
          }
          // .icon-dropdown-hidden-filter {
          //   width: 28px;
          //   height: 100%;
          //   display: flex;
          //   flex-direction: column;
          //   justify-content: center;
          //   align-items: flex-end;
          //   cursor: pointer;
          //   border-right: 1px solid #c4c4c4;
          // }
          // .search-icon-container {
          //   width: 48px;
          //   height: 100%;
          //   display: flex;
          //   flex-direction: column;
          //   justify-content: center;
          //   align-items: center;
          //   border-left: 1px solid #c4c4c4;
          // }
          // .search-icon-container:hover {
          //   cursor: pointer;
          // }
          // .container-item-action {
          //   display: flex;
          //   flex-direction: row;
          //   justify-content: center;
          //   align-items: center;
          //   height: 100%;
          // }
          // .clear-container {
          //   width: auto;
          //   height: 100%;
          //   display: flex;
          //   flex-direction: column;
          //   justify-content: center;
          //   align-items: center;
          //   margin-right: 8px;
          // }
          .icon-dropdown-hidden-filter {
            width: 48px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border-right: 1px solid #c4c4c4;
          }
          .search-icon-container {
            width: 48px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-left: 1px solid #c4c4c4;
          }
          .search-icon-container:hover {
            cursor: pointer;
          }
          .container-item-action {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 100%;
            flex: 1;
          }
          .clear-container {
            width: auto;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-right: 8px;
            flex: 1;
          }
          .clear-text {
            margin: 0;
            color: #c4c4c4;
            font-size: 16px;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          }
          .clear-text.active {
            color: ${themeVariables.colors.primary};
            cursor: pointer;
          }
          .clear-text.active:hover {
            color: ${themeVariables.colors.bodyText};
          }
          .icon-dropdown-hidden-filter-mobile {
            display: none;
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .clear-container {
              display: none;
            }
            .search-icon-container {
              display: none;
            }
            .icon-dropdown-hidden-filter {
              display: none;
            }
            .icon-dropdown-hidden-filter-mobile {
              display: block;
              cursor: pointer;
            }
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .header-filter-action-bottom {
              display: flex;
              justify-content: space-between;
              gap: 32px;
            }
          }
          .nav-submenu {
            padding: 16px;
            background: #ffffff;
            z-index: 100;
            border-radius: 2px;
            text-align: left;
            font-size: 18px;
            cursor: initial;
            // border-right: 1px solid #c4c4c4;
          }
          .nav-submenu .submenu-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 44px;
          }
          .nav-submenu .submenu-item .submenu-item-title {
            width: 330px;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 24px;
          }
          .nav-submenu .submenu-item .submenu-item-dropdown {
            width: 100%;
            font-size: 14px;
          }

          .icon-dropdown {
            cursor: pointer;
            width: 20px;
            height: 28px;
          }
          .action-desktop .filter-action .refine-text {
            border: none;
            width: auto;
            height: 32px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .action-mobile {
            height: 112px;
            max-width: 308px;
            background: #f8f9fa;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            display: none;
          }
          .header-filter-responsive {
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 1px solid #c4c4c4;
            box-sizing: border-box;
            background: #ffffff;
            font-weight: 600;
            text-transform: uppercase;
            border-right: none;
          }
          .header-filter-action,
          .header-filter-action-desktop {
            display: none;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 62px;
            background: #ffffff;
            /* Default text */

            border: 1px solid #c4c4c4;
            box-sizing: border-box;
            padding: 0 16px;
          }
          .filter-text {
            color: #ffffff;
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 24px;
          }
          .clear-filter {
            border-radius: 4px;
            width: 120px;
            height: 40px;
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            border: none;
            display: block;
            align-items: center;
            color: #ffffff;
            background: #1b2833;
            border-radius: 4px;
            text-transform: uppercase;
          }
          .sub-item-container {
            margin-top: 16px;
            width: 100%;
          }
          .clear-filter.apply.photo_ac:hover {
            background: #1d7ab3;
          }
          .clear-filter.apply.illust_ac:hover {
            background: #d73a4e;
          }
          .clear-filter.apply.silhouette_ac:hover {
            background: #41b9b8;
          }
          .clear-filter.apply.design_ac:hover {
            background: #ffa823;
          }

          .clear-filter.clear {
            background: #ffffff;
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            color: #1b2833;
            border: 2px solid #1b2833;
            box-sizing: border-box;
            border-radius: 4px;
          }
          .clear-filter.clear.photo_ac:hover {
            border: 1px solid #1d7ab3;
            color: #1d7ab3;
          }
          .clear-filter.clear.illust_ac:hover {
            border: 1px solid #d73a4e;
            color: #d73a4e;
          }
          .clear-filter.clear.silhouette_ac:hover {
            border: 1px solid #41b9b8;
            color: #41b9b8;
          }
          .clear-filter.clear.design_ac:hover {
            border: 1px solid #ffa823;
            color: #ffa823;
          }
          .nav-submenu-wrapper {
            position: relative;
            display: flex;
            flex-direction: column;
            background: transparent;
            z-index: 900;
            background: #ffffff;
            box-shadow: 0px 0px 4px rgb(0 0 0 / 25%);
            border-radius: 4px 0px 0px 0px;
            max-width: 308px;
            height: 100%;
            right: 0;
            overflow: scroll;
            float: right;
          }
          .nav-submenu-wrapper.toggle {
            overflow: hidden;
            right: 0;
          }
          .nav-submenu-wrapper.banner {
            top: 220px;
          }
          .nav-submenu-wrapper .toggle.banner {
            top: 220px;
          }
          .nav-submenu {
            flex: 1;
            overflow-y: auto;
          }
          .submenu-list {
            margin-bottom: 100px;
          }
          .submenu-item-radio {
            align-items: center;
            font-size: 14px;
            line-height: 25px;
          }

          .model-count-options {
            flex-direction: column;
            align-items: flex-start;
          }
          .model-count-row {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
          }
          .imageTitle {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
          }
          .submenu {
            padding-bottom: 24px;
            border-bottom: 1px solid #e3e3e3;
          }
          .submenu-item-title {
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 24px;
            color: #000000;
          }
          .submenu-item.submenu-item-title {
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 21px;
          }
          .submenu-item-radio.sort-by,
          .submenu-item-radio.shape {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .submenu-item-radio.number-people {
            display: flex;
            flex-direction: column;
          }
          .sub-radio-container.number-people {
            gap: 16px;
          }
          .submenu-item-radio.release,
          .submenu-item-radio.license {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
          .submenu-item-radio.excludekeyword {
            margin-top: 16px;
          }
          .submenu-item-radio.imagetitle {
            margin-top: 16px;
          }
          .submenu-item-radio.creator {
            margin-top: 16px;
          }
          .submenu-item-radio.age {
            margin-top: 16px;
          }
          .submenu-item-radio.category span {
            font-family: 'Work Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 21px;
          }
          .submenu-item-radio.category {
            margin-top: 16px;
            height: auto;
          }
          .filter-action {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 58px;
          }
          .sub-radio-container {
            width: 100%;
            height: 60px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          }
          .sub-radio-container.calc {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 16px;
          }

          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .nav-submenu {
              padding-bottom: 64px;
            }
          }

          @media (max-width: 780px) {
            .action-mobile {
              height: auto;
              max-width: 308px;
              background: #f8f9fa;
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
              display: block;
            }
            .action-desktop {
              display: none;
            }
            .header-filter-responsive {
              height: 60px;
              border: none;
              border: 1px solid #c4c4c4;
            }
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .filter-action {
              display: flex;
              flex-direction: column;
              alight-item: center;
              width: 120px;
            }
            .container-item-action {
              flex: 0;
            }
            .nav-submenu {
              overflow-y: scroll;
            }
            .action-mobile {
              max-width: 100%;
              background: #f8f9fa;
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            }
            .nav-submenu-wrapper {
              width: 100%;
              top: 0;
              padding-bottom: 0;
              animation: closeModal 0.4s ease-out forwards;
            }
            .nav-submenu-wrapper.toggle {
              max-width: 100%;
              top: 0;
              left: 0;
              animation: openModal 0.4s ease-out forwards;
            }
            .nav-submenu-wrapper.banner {
              top: 90px;
            }
            .nav-submenu-wrapper .toggle.banner {
              top: 90px;
            }
            .header-filter-action {
              border: none;
              padding: 0 15%;
              border-bottom: 1px solid #c4c4c4;
              box-sizing: border-box;
            }
            .header-filter-responsive {
              height: 60px;
              border: none;
              border-bottom: 1px solid #c4c4c4;
              display: flex;
              padding: 0 10px;
              align-items: center;
              flex-direction: row-reverse;
            }
            .clear-filter {
              background: #1b2833;
              border-radius: 4px;
              width: 100%;
              height: 40px;
            }
            .clear-filter.clear {
              font-family: 'Work Sans';
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              letter-spacing: 0.03em;
              text-transform: uppercase;
              /* CULTURED */
              color: ${themeVariables.colors.primary};
              color: #1b2833;
            }
            .clear-filter.clear:hover {
              color: #1b2833;
            }
            .header-filter-action-desktop {
              display: none;
            }
            .submenu-item-radio.sort-by,
            .submenu-item-radio.shape {
              display: flex;
            }
            .submenu-item-radio.number-people {
              margin-top: 16px;
              display: flex;
            }
            .submenu-item-radio.release,
            .submenu-item-radio.license {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }
            .submenu-item-radio.excludekeyword {
              height: 78px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
            .submenu-item-radio.imagetitle {
              margin-top: 16px;
            }
            .submenu-item-radio.creator {
              margin-top: 16px;
            }
            .submenu-item-radio.age {
              margin-top: 16px;
            }
            .sub-radio-container.calc {
              justify-content: space-around;
            }
          }
          @keyframes openModal {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0);
            }
          }

          @keyframes closeModal {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(100%);
            }
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  searchState: selectSearch,
  currentLang: makeSelectCurrentLang(),
  isLocaleInPath: makeSelectIsLocaleInPath(),
});

const mapDispatchToProps = (dispatch) => ({
  onChangeExcludeKeyword: (value) => {
    dispatch(changeExcludeKeyword(value));
  },
  onChangeCategory: (options) => {
    dispatch(changeCategory(options));
  },
  onChangeExcludeCategory: (options) => {
    dispatch(changeExcludeCategory(options));
  },
  onChangeCreatorName: (value) => {
    dispatch(changeCreatorName(value));
  },
  onChangeExcludeCreatorName: (value) => {
    dispatch(changeExcludeCreatorName(value));
  },
  onChangeImageType: (value) => {
    dispatch(changeImageType(value));
  },
  onChangeOrderBy: (value) => {
    dispatch(changeOrderBy(value));
  },
  onChangeShape: (value) => {
    dispatch(changeShape(value));
  },
  onChangeImageId: (value) => {
    dispatch(changeImageId(value));
  },
  onChangeImageTitle: (value) => {
    dispatch(changeImageTitle(value));
  },
  onChangeColor: (value) => {
    dispatch(changeColor(value));
  },
  onChangeModelCount: (value) => {
    dispatch(changeModelCount(value));
  },
  onChangeModelAge: (options) => {
    dispatch(changeModelAge(options));
  },
  onChangeOrientation: (value) => {
    dispatch(changeOrientation(value));
  },
  onChangeModelRelease: (value) => {
    dispatch(changeModelRelease(value));
  },
  onChangeLicense: (value) => {
    dispatch(changeLicense(value));
  },
  onClearSearch: () => {
    dispatch(clearSearch());
  },
  onChangeOpenOrderBy: (value) => {
    dispatch(changeOpenOrderBy(value));
  },
  onChangeOpenImageType: (value) => {
    dispatch(changeOpenImageType(value));
  },
  onChangeOpenOrientation: (value) => {
    dispatch(changeOpenOrientation(value));
  },
  onChangeOpenKeywords: (value) => {
    dispatch(changeOpenKeywords(value));
  },
  onChangeOpenCategory: (value) => {
    dispatch(changeOpenCategory(value));
  },
  onChangeOpenColor: (value) => {
    dispatch(changeOpenColor(value));
  },
  onChangeOpenNumberOfPeople: (value) => {
    dispatch(changeOpenNumberOfPeople(value));
  },
  onChangeOpenAge: (value) => {
    dispatch(changeOpenAge(value));
  },
  onChangeOpenModelRelease: (value) => {
    dispatch(changeOpenModelRelease(value));
  },
  onChangeOpenCreator: (value) => {
    dispatch(changeOpenCreator(value));
  },
  onChangeOpenImageTitle: (value) => {
    dispatch(changeOpenImageTitle(value));
  },
  onChangeOpenReleases: (value) => {
    dispatch(changeOpenReleases(value));
  },
  onChangeOpenLicense: (value) => {
    dispatch(changeOpenLicense(value));
  },
  onToggleFilterSearch: (value) => {
    dispatch(changeToggleFilterSearch(value));
  },
  searchPhoto: (value) => {
    dispatch(searchPhoto(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(RefineSearch);
